module.exports = __webpack_public_path__ + "static/vrouw-hardlopen-a1eac3162465743ee2b3d16e73c0166e.svg";